"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMOCODE_AVAILABILITY_CODE = void 0;
exports.PROMOCODE_AVAILABILITY_CODE = {
    AVAILABLE: 'AVAILABLE',
    EXPIRED: 'EXPIRED',
    CONDITIONS_NOT_MET: 'CONDITIONS_NOT_MET',
    NOT_EXIST: 'NOT_EXIST',
    NOT_AVAILABLE: 'NOT_AVAILABLE'
};
//# sourceMappingURL=promocodeAvailabilityCode.js.map